export default "__VITE_ASSET__BPuXmfYR__"